import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import EnterpriseAccreditedRepository from '@/shared/http/repositories/realestate/enterpriseaccredited'
import { loading } from '@/shared/utils/UIHelper'
export default {
  mixins: [ActionsForm],
  name: 'Tabenterprise',
  components: {HeadDetailsGama},
  props: ['dataCredenciada'],
  data () {
    return {
      columns: ['IMOBILIÁRIA', 'N° CORRETORES', 'CIDADE', 'UF', 'STATUS', 'DT. DE INSERÇÃO', ''],
      columnsModal: ['IMOBILIÁRIA', 'N° CORRETORES', 'CIDADE', 'UF', 'STATUS'],
      dataTable: [],
      serachData: [],
      buscaImobiliaria: [],
      searchingLf: true,
      datasearching: [],
      dataModal: [],
      dataImobiliaria: [],
      showHeader: true
    }
  },
  watch: {
    serachData (newvalue, oldvalue) {
      if (newvalue !== '') {
        this.searching(newvalue)
      } else {
        this.datasearching = this.dataTable
      }
    },
    buscaImobiliaria (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaImobiliarioAdd(newvalue)
      } else {
        this.dataModal = this.dataImobiliaria
      }
    }
  },
  mounted () {
    this.getAllByEnterprise()
  },
  methods: {
    getAllByEnterprise () {
      loading.push()
      EnterpriseAccreditedRepository.REEmpreendimentoCredenciada(this.dataCredenciada.id)
        .then(Response => {
          this.dataTable = Response.data.data
          this.datasearching = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    saveLstGuid () {
      loading.push()
      let lstClass = document.querySelectorAll('.inputchecktable')
      let lstIds = []
      lstClass.forEach((Element) => {
        if (Element.checked === true) lstIds.push(Element.id)
      })
      let data = {
        lst: lstIds
      }
      EnterpriseAccreditedRepository.SendNewCredenciada(this.dataCredenciada.id, data)
        .then(Response => {
          this.$refs.modalDetails.hide()
          this.getAllByEnterprise()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    searching (value) {
      this.searchingLf = true
      this.datasearching = this.dataTable.filter((Element) => Element.credenciada.nome.toUpperCase().indexOf(value.toUpperCase()) > -1)
    },
    BuscaImobiliarioAdd (value) {
      this.searchingLf = true
      this.dataModal = this.dataModal.filter((Element) => Element.nome.toUpperCase().indexOf(value.toUpperCase()) > -1)
    },
    deleteEnterprise (id) {
      loading.push()
      EnterpriseAccreditedRepository.Delete(id)
        .then(Response => {
          this.getAllByEnterprise()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    closeModal () {
      this.$refs.modalDetails.hide()
    },
    AddNewCreden () {
      loading.push()
      EnterpriseAccreditedRepository.GetAllByNotEmpreendimento(this.dataCredenciada.id)
        .then(Response => {
          this.dataModal = Response.data.data
          this.dataImobiliaria = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
      this.$refs.modalDetails.show()
    },
    checkAll (e) {
      let checkClass = document.querySelectorAll('.inputchecktable')
      if (e.target.checked === true) {
        checkClass.forEach((Element) => { Element.checked = true })
      } else {
        checkClass.forEach((Element) => { Element.checked = false })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/tabenterprise/tabenterprise.js